import { render, staticRenderFns } from "./POICamping.vue?vue&type=template&id=488e470c"
import script from "./POICamping.js?vue&type=script&lang=js&external"
export * from "./POICamping.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports